import { Stack, Typography } from '@chronosphereio/chrono-ui';
import { CheckboxBlank as CheckboxBlankIcon } from 'mdi-material-ui';

interface StaticLegendItemProps {
  swatchColor: string;
  label: string;
}

export const StaticLegendItem = ({ swatchColor, label }: StaticLegendItemProps) => {
  return (
    <Stack spacing={0.5} sx={{ alignItems: 'center' }} direction="row">
      <CheckboxBlankIcon
        sx={{
          fontSize: '16px',
        }}
        style={{
          color: swatchColor,
        }}
      />
      <Typography variant="body2">{label}</Typography>
    </Stack>
  );
};

interface StaticLegendProps {
  children: React.ReactNode;
}

export const StaticLegend = ({ children }: StaticLegendProps) => {
  return (
    <Stack
      data-testid="legend"
      direction="row"
      spacing={1.5}
      sx={{ padding: 1, backgroundColor: (t) => t.palette.background.container }}
    >
      {children}
    </Stack>
  );
};
